import { Autocomplete, AutocompleteOption } from '@healthinal/ui';
import { ScreeningCaseListItemDto, useGetScreeningCases } from '../../../api/created/screening.ts';
import { FETCH_ALL_PAGE_SIZE } from '../../../api/pagination.ts';
import { formatDate } from '../../../utils/date.ts';

interface Props {
  value: ScreeningCaseListItemDto | null;
  onChange: (screeningCase: ScreeningCaseListItemDto | null) => void;
  activeOnly?: boolean;
  // The cases are only loaded while enabled, for example while the dialog is open.
  enabled?: boolean;
}

export function SelectScreeningCase({ value, onChange, activeOnly = false, enabled = true }: Props) {
  const { data: screeningCasesPage, isPending } = useGetScreeningCases(
    { activeOnly, page: 0, size: FETCH_ALL_PAGE_SIZE },
    { query: { enabled } },
  );
  const screeningCases = screeningCasesPage?.content ?? [];

  return (
    <Autocomplete
      value={value}
      onChange={(_, newValue) => onChange(newValue)}
      loading={isPending}
      options={screeningCases}
      placeholder={'Screening-Auftrag auswählen'}
      getOptionLabel={(option) => getScreeningCaseLabel(option)}
      isOptionEqualToValue={(option, selected) => option.screeningCaseId === selected.screeningCaseId}
      renderOption={(props, option) => (
        <AutocompleteOption {...props} key={option.screeningCaseId}>
          {getScreeningCaseLabel(option)}
        </AutocompleteOption>
      )}
    />
  );
}

// The same name as the Gruppenbezeichnung column of the screening list, with the date it was entered.
function getScreeningCaseLabel(screeningCase: ScreeningCaseListItemDto) {
  const name =
    screeningCase.groupName?.trim() ||
    `${screeningCase.lastName ?? ''} ${screeningCase.firstName ?? ''}`.trim() ||
    'Ohne Bezeichnung';
  const created = formatDate(screeningCase.created);
  return created ? `${name} (${created})` : name;
}
